import React, { useEffect } from "react";
import Loader from "../../../loader/Loader";
import MeasurementImage from "../../../assets/image/Measurement.svg";
import PlanningImage from "../../../assets/image/Planning.svg";
import InteriorDesignImage from "../../../assets/image/InteriorDesign.svg";
import { FEATURE_FLAGS } from '../../../constants/featureFlags';

export default function ServiceSelectionStep1({
  Services = [],
  selectedService,
  fetchState,
  setSelectedService,
  setServiceName,
  setServiceDescription,
  setServicePrice,
  skey
}) {

  const handleSelect = (service) => {
    setSelectedService(service);
    setServiceName(service.ServiceName);
    setServiceDescription(service.Description);
    setServicePrice(service.Price);
  };

  useEffect(() => {
    if (
      skey === "planning" &&
      fetchState === "fetched" &&
      Services.length > 0 &&
      !selectedService?.ServiceName
    ) {
      const planningService = Services.find(
        (s) => s.ServiceName.toLowerCase() === "kitchen planning service"
      );
      if (planningService) {
        handleSelect(planningService);
      }
    }
  }, [skey, fetchState, Services]);

  const getServiceImage = (serviceName) => {
    if (serviceName.toLowerCase().includes("measurement")) {
      return MeasurementImage;
    } else if (serviceName.toLowerCase().includes("planning")) {
      return PlanningImage;
    } else if (serviceName.toLowerCase().includes("interior design")) {
      return InteriorDesignImage;
    }
    return null;
  };

  const visibleServices = FEATURE_FLAGS.INTERIOR_DESIGN_ENABLED
    ? Services
    : Services.filter(
        (s) => !s.ServiceName?.toLowerCase().includes('interior design')
      );

  return (
    <div className="step-1">
      <h3>What type of appointment do you want to make?</h3>

      {fetchState !== "fetched" ? (
        <Loader />
      ) : (
        <div className="appointment-card">
          {visibleServices.map((service) => {
            const isSelected =
              selectedService?.ServiceName === service.ServiceName;

            const isMeasurement =
              service.ServiceName.toLowerCase().includes("measurement");

            return (
              <div
                key={service.ServiceName}
                className={`appointment-list ${
                  isSelected ? "selected-service" : ""
                }`}
                onClick={() => handleSelect(service)}
              >
                <div className="card-header">
                  {getServiceImage(service.ServiceName) && (
                    <img
                      src={getServiceImage(service.ServiceName)}
                      alt={service.ServiceName}
                      className="service-image"
                    />
                  )}

                  <div className="card-info">
                    <h4 className="heading">{service.ServiceName}</h4>
                    <h6 className="sub-title">{service.ServiceType}</h6>
                  </div>

                  <div className="service-meta">
                    <div className="price-container">
                      <div className="price">
                        <span className="currency-sup">Dhs</span>
                        {service.Price?.toString().includes(".") ? (
                          <>
                            {service.Price.toString().split(".")[0]}
                            <span className="decimal-sub">
                              .{service.Price.toString().split(".")[1]}
                            </span>
                          </>
                        ) : (
                          service.Price
                        )}
                      </div>

                      {isMeasurement && (
                        <>
                          <div className="price-sub">
                            for the first room
                          </div>
                          <div className="price-sub light">
                            + Dhs 50 per additional room
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {service.Description && <p>{service.Description}</p>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
